module.exports = __webpack_public_path__ + "static/media/muestra.72b8de55.svg";